export const subfolder = '/buy/plan';
export const moversFolder = 'move';
export const checkoutFolder = 'checkout';
export const accountFolder = 'account';



/** WEBPACK FOOTER **
 ** ./client/util/constants/directory.js
 **/